// Client-safe half of ./sources: the stable string key for an edit source.
//
// It lives in its own module because `sources.ts` reaches for node:crypto in
// `hashValue`, and webpack cannot resolve the "node:" scheme for a browser
// bundle: a client component importing `sourceKey` from `sources.ts` fails the
// build with UnhandledSchemeError. The type import below is erased at compile
// time, so nothing in this module pulls `sources.ts` into a client bundle.
//
// `sources.ts` re-exports this function, so server code and tests keep
// importing `sourceKey` from '@/lib/content-edit/sources'.
import type { EditSource } from './sources'

export function sourceKey(source: EditSource): string {
  switch (source.kind) {
    case 'mdx':
      return `mdx:${source.slug}:${source.field}`
    case 'copy':
      return `copy:${source.file}:${source.path}`
    case 'override':
      return `override:${source.entity}:${source.slug}.${source.field}`
    case 'image':
      return `image:${source.slot}`
  }
}
